import React from 'react';
import { InkindSupportSidebar } from './InkindSupportSidebar';

interface InkindSupportSidebarContainerProps {
  inkindRouteId: string;
  isSamplePage?: boolean;
}

export default function RightSideBarContainer({
  inkindRouteId,
  isSamplePage,
}: InkindSupportSidebarContainerProps): JSX.Element {
  return <InkindSupportSidebar inkindRouteId={inkindRouteId} isSamplePage={isSamplePage} />;
}
